import { render, staticRenderFns } from "./AccountAssetFormInfo.vue?vue&type=template&id=45e19e0a&scoped=true&"
import script from "./AccountAssetFormInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountAssetFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAssetFormInfo.vue?vue&type=style&index=0&id=45e19e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e19e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
